export const SNCR_INTEGRATION_SETTING = "Health.Sncr.IntegrationEnabled";

export const SNCR_TENANT_INTEGRATION_SETTING = "Health.Sncr.TenantIntegrationEnabled";

export const SNCR_PRESCRIPTION_CERTIFICATE_REQUIRED_SETTING = "Health.Sncr.PrescriptionCertificateRequired";

export function isSncrFeatureEnabled(): boolean {
    return abp.setting.getBoolean(SNCR_INTEGRATION_SETTING);
}

export function isSncrIntegrationEnabled(): boolean {
    return isSncrFeatureEnabled() && abp.setting.getBoolean(SNCR_TENANT_INTEGRATION_SETTING);
}

export function isPrescriptionCertificateRequired(): boolean {
    return abp.setting.getBoolean(SNCR_PRESCRIPTION_CERTIFICATE_REQUIRED_SETTING);
}

export function sncrPortalUrlFrom(configured: string | undefined): string {
    return configured?.startsWith("http") ? configured : "";
}
